import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {SpotifyTagsService} from "../services/spotify-tags-service";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private spotifyTagsService: SpotifyTagsService, public router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 400) {
                        // Validation error, handled by component itself
                        return next.handle(request);
                    }
                    if (error.status === 401 || error.status === 403) {
                        this.router.navigateByUrl('/signup');
                        return next.handle(request);
                    }
                    if (error.status === 404) {
                        this.router.navigateByUrl('/404');
                        return next.handle(request);
                    }
                    this.spotifyTagsService.error();
                    return throwError(error.message);
                })
            )
    }
}
